import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.transferToTLBB'),
    loading: !_ctx.isReady
  }, {
    default: _withCtx(() => [
      (!_ctx.pointToCoinRate)
        ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            message: _ctx.$t('message.fetchError'),
            type: "error",
            "show-icon": ""
          }, {
            description: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.fetchRate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.reload')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["message"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.userInfo?.point)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  message: `Bạn đang có ${_ctx.number_format(_ctx.userInfo?.point)} ${_ctx.$t('labelText.user_point')} chưa nhận trong Game`,
                  class: "mb-20",
                  "show-icon": ""
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            ((!_ctx.userInfo?.coin && !_ctx.userInfo?.promotion_coin) || (!Math.floor((_ctx.userInfo?.coin || 0) / _ctx.pointToCoinRate) && !Math.floor((_ctx.userInfo?.promotion_coin || 0) / _ctx.pointToCoinRate)))
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 1,
                  message: "Tài khoản không đủ tiền để chuyển vào game",
                  type: "warning",
                  "show-icon": ""
                }, {
                  description: _withCtx(() => [
                    _createElementVNode("div", null, "Tài khoản bạn không còn đủ " + _toDisplayString(_ctx.$t('labelText.user_point')) + " để thực hiện hành động này.", 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_form, {
                  key: 2,
                  ref: "form",
                  model: _ctx.formModel,
                  onFinish: _ctx.onFinish,
                  rules: _ctx.formRule,
                  scrollToFirstError: true,
                  "label-col": { span: 4 },
                  "wrapper-col": { span: 20 }
                }, {
                  default: _withCtx(() => [
                    (Math.floor((_ctx.userInfo?.coin || 0) / _ctx.pointToCoinRate))
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          label: _ctx.$t('labelText.user_coin'),
                          name: "coin",
                          help: _ctx.formModel.coin ? `${_ctx.$t('text.preview')}: ${_ctx.number_format(_ctx.formModel.coin)}` : null
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.formModel.coin,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.coin) = $event)),
                              min: 0,
                              max: _ctx.userInfo?.coin
                            }, {
                              addonAfter: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  size: "small",
                                  type: "ghost",
                                  onClick: _cache[0] || (_cache[0] = () => { _ctx.formModel.coin = _ctx.userInfo?.coin as number })
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('text.max')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "max"])
                          ]),
                          _: 1
                        }, 8, ["label", "help"]))
                      : _createCommentVNode("", true),
                    (Math.floor((_ctx.userInfo?.promotion_coin || 0) / _ctx.pointToCoinRate))
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          label: _ctx.$t('labelText.user_promotion_coin'),
                          name: "promotion_coin",
                          help: _ctx.formModel.promotion_coin ? `${_ctx.$t('text.preview')}: ${_ctx.number_format(_ctx.formModel.promotion_coin)}` : null
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.formModel.promotion_coin,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.promotion_coin) = $event)),
                              min: 0,
                              max: _ctx.userInfo?.promotion_coin
                            }, {
                              addonAfter: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  size: "small",
                                  type: "ghost",
                                  onClick: _cache[2] || (_cache[2] = () => { _ctx.formModel.promotion_coin = _ctx.userInfo?.promotion_coin as number })
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('text.max')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "max"])
                          ]),
                          _: 1
                        }, 8, ["label", "help"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_form_item, { "wrapper-col": { lg: {span: 20, offset: 4}, md: {span:24, offset: 0}} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          "html-type": "submit",
                          loading: _ctx.isLoading,
                          disabled: !(_ctx.formModel.coin + _ctx.formModel.promotion_coin)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.transfer')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "onFinish", "rules"]))
          ]))
    ]),
    _: 1
  }, 8, ["title", "loading"]))
}